"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLocationUpdateInputSchema = exports.APosLocationCreateInputSchema = exports.APosLocationSchema = exports.APosOnlinePresenceSchema = exports.APosLocationStatusSchema = exports.APosAddressSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAddressSchema = zod_1.z.object({
    street: zod_1.z.string().min(1).max(200),
    street2: zod_1.z.string().max(200).optional(),
    city: zod_1.z.string().min(1).max(100),
    state: zod_1.z.string().min(1).max(100),
    zip: zod_1.z.string().min(1).max(20),
    country: zod_1.z.string().max(100).default('US'),
});
exports.APosLocationStatusSchema = zod_1.z.enum(['active', 'inactive']);
exports.APosOnlinePresenceSchema = zod_1.z.object({
    googleBusiness: zod_1.z.object({
        url: zod_1.z.string().url().optional(),
        placeId: zod_1.z.string().max(200).optional(),
        cid: zod_1.z.string().max(100).optional(),
    }).optional(),
    facebook: zod_1.z.object({
        url: zod_1.z.string().url().optional(),
        pageId: zod_1.z.string().max(100).optional(),
    }).optional(),
    instagram: zod_1.z.object({
        url: zod_1.z.string().url().optional(),
        handle: zod_1.z.string().max(100).optional(),
        businessAccountId: zod_1.z.string().max(100).optional(),
    }).optional(),
    yelp: zod_1.z.object({
        url: zod_1.z.string().url().optional(),
    }).optional(),
    tripAdvisor: zod_1.z.object({
        url: zod_1.z.string().url().optional(),
    }).optional(),
    website: zod_1.z.string().url().optional(),
}).optional();
exports.APosLocationSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    address: exports.APosAddressSchema,
    phone: zod_1.z.string().min(1).max(30),
    timezone: zod_1.z.string().min(1).max(50),
    stateTaxRate: zod_1.z.number().min(0).max(1).describe('@deprecated - tax handled at product level'),
    cityTaxRate: zod_1.z.number().min(0).max(1).describe('@deprecated - tax handled at product level'),
    allowOverselling: zod_1.z.boolean().default(true),
    acceptsOnlineOrders: zod_1.z.boolean().default(false),
    acceptsDelivery: zod_1.z.boolean().default(false),
    deliveryRadius: zod_1.z.number().positive().optional(),
    deliveryFee: zod_1.z.number().nonnegative().optional(),
    deliveryMinOrder: zod_1.z.number().nonnegative().optional(),
    pickupEnabled: zod_1.z.boolean().default(false),
    operatingHours: zod_1.z.record(zod_1.z.string(), zod_1.z.object({
        open: zod_1.z.string().regex(/^\d{2}:\d{2}$/),
        close: zod_1.z.string().regex(/^\d{2}:\d{2}$/),
        closed: zod_1.z.boolean().default(false),
    })).optional(),
    // Business registration (IRS compliance for multi-entity B2B)
    ein: zod_1.z.string().regex(/^\d{2}-\d{7}$/).optional().describe('EIN for this location (XX-XXXXXXX)'),
    legalEntityName: zod_1.z.string().max(200).optional().describe('Registered business name for this location'),
    onlinePresence: exports.APosOnlinePresenceSchema,
    status: exports.APosLocationStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLocationCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(150),
    address: exports.APosAddressSchema,
    phone: zod_1.z.string().min(1).max(30),
    timezone: zod_1.z.string().min(1).max(50),
    stateTaxRate: zod_1.z.number().min(0).max(1).optional().default(0),
    cityTaxRate: zod_1.z.number().min(0).max(1).optional().default(0),
    allowOverselling: zod_1.z.boolean().optional(),
    acceptsOnlineOrders: zod_1.z.boolean().optional(),
    acceptsDelivery: zod_1.z.boolean().optional(),
    deliveryRadius: zod_1.z.number().positive().optional(),
    deliveryFee: zod_1.z.number().nonnegative().optional(),
    deliveryMinOrder: zod_1.z.number().nonnegative().optional(),
    pickupEnabled: zod_1.z.boolean().optional(),
    operatingHours: exports.APosLocationSchema.shape.operatingHours,
    ein: zod_1.z.string().regex(/^\d{2}-\d{7}$/).optional(),
    legalEntityName: zod_1.z.string().max(200).optional(),
    onlinePresence: exports.APosOnlinePresenceSchema,
});
exports.APosLocationUpdateInputSchema = exports.APosLocationCreateInputSchema.partial().extend({
    status: exports.APosLocationStatusSchema.optional(),
});
//# sourceMappingURL=location.schema.js.map